import get from 'Utils/lodash.get';
/**
 * Field is required when:
 * - has required is true in validation params
 * - has requiredIf in validation params and locator in model is truthy
 * - has requiredUnless in validation params and locator in model is falsy
 * - has requiredIfEqual in validation params and locator is equal to passed param
 * @param validateParams
 * @param model
 * @returns {boolean}
 */
// TODO: Implement requiredIfAnd dynamic changes
// eslint-disable-next-line default-param-last
export function isFieldRequired(validateParams = {}, model) {
  const { required, requiredIf, requiredUnless, requiredIfEqual, requiredIfAnd } = validateParams;
  let requiredIfEqualValue1 = [];
  if (requiredIfEqual) requiredIfEqualValue1 = Array.isArray(requiredIfEqual[1]) ? requiredIfEqual[1] : [requiredIfEqual[1]];
  return Boolean(required || requiredIfAnd
    || (requiredIf && get(model, requiredIf))
    || (requiredUnless && !get(model, requiredUnless))
    || (requiredIfEqual && Array.isArray(requiredIfEqual)
      && requiredIfEqualValue1.includes(get(model, requiredIfEqual[0]))));
}
